export default __webpack_public_path__ + "static/media/Monk's Gauntlets of the Spilling Blood.a95a0c12.jpg";